export function getScrollTop() {
  return document.documentElement.scrollTop || document.body.scrollTop
}

export function setScrollTop(position) {
  document.documentElement.scrollTop = position
  document.body.scrollTop = position
}
